import { NgClass, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogContent } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import {
  PopupFooterComponent,
  PopupHeaderComponent,
} from 'shared/components/molecules';
import { PopupHostComponent } from 'shared/components/organisms';
import { Nl2brPipe } from 'shared/pipes/nl2br.pipe';

@Component({
    selector: 'app-dialog',
    templateUrl: './stock-popup.component.html',
    imports: [
        PopupHeaderComponent,
        PopupFooterComponent,
        MatDialogContent,
        TranslateModule,
        NgIf,
        Nl2brPipe,
        NgClass,
    ],
    styles: ``
})
export class StockPopupComponent extends PopupHostComponent {
  public get contentData(): string {
    return (this.data.contentData as string) ?? '';
  }

  public override onClose(): void {
    this.dialogRef.close();
  }
}
